import React from "react"
import styled from "styled-components"
import media from "../utils/media"
import vars from "./../utils/variables"
import * as PropTypes from "prop-types"

import Container from "./container"
import Video from "./video"

const propTypes = {
  data: PropTypes.object.isRequired
}

const TitleContainer = styled(Container)`
  display: block;
`

const Title = styled.h1`
  display: inline-block;
  text-transform: uppercase;
  border-top: 1px solid ${vars.colorText};
  border-bottom: 1px solid ${vars.colorText};
  padding: 0.3rem 0 0.45rem;
  margin: 1.25rem 0;
`

const ContentContainer = styled(Container)`
  margin-bottom: 0;
  padding-bottom: 1.25rem;
`

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

const urlRegex = /href="(.*?)"/g

class Summary extends React.Component {
  render() {
    return (
      <div>
        <TitleContainer>
          <Title>{this.props.data.title}</Title>
        </TitleContainer>
        <ContentContainer>
          <Video
            youTubeId={this.props.data.youTubeId}
            youTubePoster={this.props.data.youTubePoster}
            hub={this.props.hub}
          />
          <Content>
            <div
              dangerouslySetInnerHTML={{
                __html: this.props.data.body.childMarkdownRemark.html.replace(
                  urlRegex,
                  this.props.hub
                    ? 'href="$1?CHKeyword=hub"'
                    : 'href="http://landrovervelar.coolhunting.com/?CHKeyword=footer"'
                )
              }}
            />
          </Content>
        </ContentContainer>
      </div>
    )
  }
}

Summary.propTypes = propTypes

export default Summary



// WEBPACK FOOTER //
// ./src/components/summary.js